import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import App from './App';
import { useLangStore } from './i18n';
import { applyPageLanguage } from './i18n/pageTranslation';

// 与 global.css --font-sans 保持一致, 强制 antd 所有组件用同一系统字体栈
// (Win 上避免 antd 默认 fallback 到宋体)
const APP_FONT =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", ' +
  '"Microsoft YaHei", "Noto Sans SC", "Hiragino Sans GB", Roboto, ' +
  'Helvetica, Arial, sans-serif';

// antd 内置文案 (分页、空状态、日期选择器等) 跟随界面语言
function Root() {
  const lang = useLangStore((s) => s.lang);
  // 业务页面里的硬编码中文由显示层翻译 (见 i18n/domTranslator.ts)
  useEffect(() => { void applyPageLanguage(lang); }, [lang]);
  return (
    <ConfigProvider
      locale={lang === 'en' ? enUS : zhCN}
      theme={{ token: { fontFamily: APP_FONT } }}
    >
      <App />
    </ConfigProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
